import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskPlaybooksListRoute: InvariantJiraRoute = {
	name: 'project-settings-playbooks-list',
	path: '/jira/servicedesk/projects/:projectKey/settings/playbooks',
	exact: true,
};
